"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSessionToUrl = exports.getIdParam = exports.getSessionParam = exports.addToUrlSearchQueries = exports.loadUrlSearchQueries = exports.URL_TIMESHEET_SEARCH_QUERY_KEY = exports.URL_CONTACTS_SEARCH_QUERY_KEY = exports.URL_SESSIONS_SEARCH_QUERY_KEY = void 0;
var Q_REGEX = /q\w*=/;
exports.URL_SESSIONS_SEARCH_QUERY_KEY = "sessions-search-q";
exports.URL_CONTACTS_SEARCH_QUERY_KEY = "contacts-search-q";
exports.URL_TIMESHEET_SEARCH_QUERY_KEY = "timesheet-search-q";
/**
 * loads Queries from url (prefixed with q i.e. q24hours)
 * or localStorage if nothing is found from url
 *
 * for now, only used in main.tsx
 * @param currentPage as dictated in main.tsx
 * @returns URLSearchParams instance with queries
 */
var loadUrlSearchQueries = function (currentPage) {
    var storageKey = "";
    if (currentPage === "sessions") {
        storageKey = exports.URL_SESSIONS_SEARCH_QUERY_KEY;
    }
    else if (currentPage === "caseform") {
        storageKey = exports.URL_CONTACTS_SEARCH_QUERY_KEY;
    }
    else if (currentPage === "timesheet") {
        storageKey = exports.URL_TIMESHEET_SEARCH_QUERY_KEY;
    }
    else {
        return new URLSearchParams("");
    }
    var q = "";
    if (Q_REGEX.test(window.location.search)) {
        q = window.location.search;
        localStorage.setItem(storageKey, q);
    }
    else {
        q = localStorage.getItem(storageKey);
    }
    if (!q) {
        return new URLSearchParams("");
    }
    var loadedQueries = new URLSearchParams(q);
    loadedQueries.forEach(function (_, key) {
        if (key[0] !== "q") {
            loadedQueries.delete(key);
        }
    });
    window.history.replaceState(null, "", "".concat(window.location.pathname, "?").concat(loadedQueries.toString()));
    return loadedQueries;
};
exports.loadUrlSearchQueries = loadUrlSearchQueries;
/**
 * adds query with prefix 'q'
 * to url and localStorage
 * in appropriate query key
 * @param queryKey key for storing the queries in localStorage
 * @param field
 * @param value
 */
var addToUrlSearchQueries = function (queryKey, field, value) {
    var q = new URLSearchParams(window.location.search);
    var f = "q".concat(field);
    if (value !== "false") {
        q.set(f, value);
    }
    else {
        q.delete(f);
    }
    var query = q.toString();
    localStorage.setItem(queryKey, query);
    window.history.replaceState(null, "", "".concat(window.location.pathname, "?").concat(q.toString()));
};
exports.addToUrlSearchQueries = addToUrlSearchQueries;
/**
 * Returns the value of the ?session=... parameter or null if it doesn't exist.
 */
var getSessionParam = function () {
    var params = new URLSearchParams(window.location.search);
    var session = params.get("session");
    return session ? Number(session) : undefined;
};
exports.getSessionParam = getSessionParam;
var getIdParam = function () {
    var params = new URLSearchParams(window.location.search);
    var session = params.get("id");
    return session ? Number(session) : undefined;
};
exports.getIdParam = getIdParam;
var addSessionToUrl = function (sessionValue) {
    var url = new URL(window.location.href);
    url.searchParams.set("session", sessionValue);
    window.history.replaceState({}, "", url);
};
exports.addSessionToUrl = addSessionToUrl;
//# sourceMappingURL=urlSearchQueryHelper.js.map